import React, { useState } from 'react';
import { SdmDialog, SdmTypography } from 'components';
import CustomFileCropper from '../styledComponents/FileCropper/CustomFileCropper';

function FileCropperDialog({
  onClose,
  onAccept,
  i18n,
  img,
  fixedHeight,
  fixedWidth,
}) {
  const [file, setFile] = useState();
  const renderTitle = () => {
    return (
      <div style={{ width: '100%', marginTop: 16 }}>
        <SdmTypography
          variant={'h1'}
          style={{ textAlign: 'center', marginTop: 20, marginBottom: 0 }}
        >
          {i18n.title}
        </SdmTypography>
      </div>
    );
  };

  const handleCroppedFile = (croppedFile) => {
    const blobURL = window.URL.createObjectURL(croppedFile);
    const img = new Image();
    img.src = blobURL;
    img.onload = function () {
      window.URL.revokeObjectURL(blobURL); // release memory
      // Use the img
      const canvas = document.createElement('canvas');
      canvas.width = fixedWidth;
      canvas.height = fixedHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, fixedWidth, fixedHeight);
      canvas.toBlob((blob) => {
        const file = new File(
          [blob],
          croppedFile.name.replace(/[^a-z0-9.]/gi, '_'),
          {
            type: croppedFile.type,
          }
        );
        setFile(file);
      }, croppedFile.type);
    };
  };

  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      agreeText={i18n.agree}
      onAgree={() => onAccept(file)}
      paperStyle={{
        borderRadius: 15,
        paddingBottom: 16,
        margin: 0,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      actionContainerStyle={{ justifyContent: 'center' }}
      actionStyle={{ height: 40, width: 158, margin: 0 }}
      actionTextStyle={{ fontSize: 20 }}
      titleStyle={{ padding: 0 }}
      contentStyle={{
        paddingTop: 16,
        paddingBottom: 22,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
      handleBody={false}
      maxWidth={false}
    >
      <div
        style={{
          textAlign: 'center',
          fontSize: 20,
        }}
      >
        {i18n.body}
        <CustomFileCropper
          img={img}
          previewTitle={i18n.preview}
          style={{
            marginTop: 40,
          }}
          onFileCropped={handleCroppedFile}
          fixedHeight={fixedHeight}
          fixedWidth={fixedWidth}
        />
      </div>
    </SdmDialog>
  );
}

export default FileCropperDialog;
